<template>
  <div class="size-selector">
    <label for="sizeSelect">Tamaño</label>
    <select id="sizeSelect" v-model="selectedSize" @change="emitSize">
      <option v-for="(sizeOption, idx) in sizes" :key="idx" :value="sizeOption">
        {{ sizeOption }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  modelValue?: number
}

interface Emits {
  (e: 'size-changed', size: number): void
  (e: 'update:modelValue', size: number): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 5,
})

const emit = defineEmits<Emits>()

const sizes = [5, 6, 7, 8, 9]
const selectedSize = ref(props.modelValue)

// Emit the size change event
const emitSize = (): void => {
  emit('size-changed', selectedSize.value)
  emit('update:modelValue', selectedSize.value)
}

// Watch for external changes to modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    selectedSize.value = newValue
  },
)

// Watch for internal changes to selectedSize
watch(selectedSize, (newValue) => {
  if (newValue !== props.modelValue) {
    emit('update:modelValue', newValue)
  }
})
</script>

<style scoped>
.size-selector {
  display: flex;
  flex-direction: column;
}

.size-selector label {
  margin-bottom: 4px;
  font-weight: normal;
}

.size-selector select {
  width: 80px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
